export function createPreviousLocationListener(history) {
  let previousLocation = history.location
  return currentLocation => {
    history.previousLocation = previousLocation
    previousLocation = currentLocation
  }
}
